import { render, staticRenderFns } from "./DelRoute.vue?vue&type=template&id=60465fca&scoped=true"
import script from "./DelRoute.vue?vue&type=script&lang=js"
export * from "./DelRoute.vue?vue&type=script&lang=js"
import style0 from "./DelRoute.vue?vue&type=style&index=0&id=60465fca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60465fca",
  null
  
)

export default component.exports